import { render } from "./view-full-text-button.vue?vue&type=template&id=3e36b72c"
import script from "./view-full-text-button.vue?vue&type=script&lang=js"
export * from "./view-full-text-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__